import { RefObject, useEffect, useState } from 'react';
import { WebGLRenderer } from 'three';

import { isDefined } from '../../../utils/variables';

/**
 * Setup a WebGLRenderer and attaches it to the reference object.
 */
export function useWebGLRenderer(ref: RefObject<HTMLElement>) {
  const [renderer, setRenderer] = useState<WebGLRenderer>();

  useEffect(() => {
    if (!isDefined(ref.current)) {
      return;
    }

    const newRenderer = new WebGLRenderer();
    newRenderer.setSize(ref.current.clientWidth, ref.current.clientHeight);
    ref.current.appendChild(newRenderer.domElement);
    setRenderer(newRenderer);

    return () => {
      newRenderer.domElement.parentElement!.removeChild(newRenderer.domElement);
    };
  }, [ref]);

  return renderer;
}
